import { Kbd, type TextProps } from '@chakra-ui/react';
import React from 'react';

import { KEYBOARD_SHORTCUTS, type KeyboardShortcut } from 'config/shortcuts';

interface Props {
  shortcut: KeyboardShortcut;
  color?: TextProps['color'];
}

const KeyboardShortcutHint: React.FC<Props> = ({ shortcut, color }) => {
  return (
    <Kbd
      flexShrink={0}
      fontFamily="body"
      fontSize="xxs"
      fontWeight="medium"
      minWidth={0}
      color={color}
    >
      {KEYBOARD_SHORTCUTS[shortcut].label}
    </Kbd>
  );
};

export default React.memo(KeyboardShortcutHint);
